<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'historicalDocs.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="loaded" 
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'historicalDocs.fields.property' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../{{ element.propertyId._id}}/home">
                      <div
                        [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired), 'document-wrapper-text-not-mandatory': (!element.mandatory || element.expired)}">
                        {{ element.propertyId.name }}</div>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="codeType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'historicalDocs.fields.codeType' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                        {{ element.data.docCode }}</div>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="codeTypeFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="paper">{{ 'historicalDocs.types.paper' | translate }}</mat-option>
                        <mat-option value="digital">{{ 'historicalDocs.types.digital' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(codeTypeFilter)"
                        class="reset-input-icon ml-n3" *ngIf="codeTypeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'historicalDocs.fields.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.type }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="typeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(typeFilter)"
                        class="reset-input-icon" *ngIf="typeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="content">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'historicalDocs.fields.content' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.content }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="contentFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(contentFilter)"
                        class="reset-input-icon" *ngIf="contentFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="reference">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'historicalDocs.fields.reference' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.reference }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="referenceFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(referenceFilter)"
                        class="reset-input-icon" *ngIf="referenceFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="dateDoc">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'historicalDocs.fields.dateDoc' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      <span *ngIf="element.data.dataDocumento">{{ element.data.dataDocumento }}</span>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="dateDocFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(dateDocFilter)"
                        class="reset-input-icon" *ngIf="dateDocFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loaded">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'historicalDocs.fields.loaded' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.loaded | dateFormat }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="loadedFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(loadedFilter)"
                        class="reset-input-icon" *ngIf="loadedFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>


                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a routerLink="../../{{ element.propertyId._id }}/documents" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                      *ngIf="!loggedUserTemporary">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                    <a routerLink="../../my-property/{{ element.propertyId._id }}" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                      *ngIf="loggedUserTemporary">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->